;(() => {
  class Memo {
    constructor() {
      this.classCache = {}
      this.cssCache = {}
    }

    addClass(element, name) {
      this.toggleClass(element, name, true)
    }

    removeClass(element, name) {
      this.toggleClass(element, name, false)
    }

    toggleClass(element, name, toggle) {
      const shouldToggle = Boolean(toggle)
      if (
        this.classCache[name] === shouldToggle &&
        element.hasClass(name) === shouldToggle
      ) {
        return
      }

      element.toggleClass(name, shouldToggle)
      this.classCache[name] = shouldToggle
    }

    css(element, id, name, val) {
      const key = `${id}/${name}`
      if (this.cssCache[key] === val) {
        return
      }

      element.css(name, val)
      this.cssCache[key] = val
    }
  }

  window.HB = window.HB || {}
  window.HB.Memo = new Memo()
})()
